"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var react_phone_input_2_1 = __importDefault(require("react-phone-input-2"));
var lodash_1 = __importDefault(require("lodash"));
require("react-phone-input-2/lib/style.css");
var styles_module_scss_1 = __importDefault(require("../../styles.module.scss"));
var SmsVerifyPhone = function (_a) {
    var onChange = _a.onChange, _b = _a.value, value = _b === void 0 ? '' : _b;
    var t = react_i18next_1.useTranslation('common').t;
    var setPhone = function (phone) {
        onChange(phone);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.sms_verify_text },
            react_1.default.createElement("h1", { className: styles_module_scss_1.default.title }, t('HELLO')),
            react_1.default.createElement("span", null, t('SMS_PAGE.TITLE')),
            react_1.default.createElement("span", null, t('SMS_PAGE.DESCRIPTION'))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.sms_verify_input },
            react_1.default.createElement(react_phone_input_2_1.default, { country: 'am', countryCodeEditable: false, onlyCountries: ['am'], value: value, disableDropdown: true, onChange: function (phone) { return setPhone(phone); }, placeholder: '374 xx xx xx xx', masks: { am: '(..) ..-..-..' }, isValid: function (value, country) {
                    if (value.length > 11 ||
                        !lodash_1.default.startsWith(value, country.dialCode)) {
                        return (t('INVALID_PHONE') + value + ', ' + country.name);
                    }
                    else if (value.length < 11 && value.length > 3) {
                        return false;
                    }
                    else {
                        return true;
                    }
                } }))));
};
exports.default = SmsVerifyPhone;
